import React from 'react'

export const IconDollar = (props={}) => {
	const { size= 16, imgSize= 16, fill="white" } = props
	return <>
		<svg xmlns="http://www.w3.org/2000/svg"
				 width={`${size}px`}
				 height={`${size}px`}
				 viewBox={`0 0 ${imgSize} ${imgSize}`}
				 fill="none"
		>
			<g clipPath="url(#clip0_1_7570)">
				<path
					d="M7.99967 14.6673C11.6816 14.6673 14.6663 11.6825 14.6663 8.00065C14.6663 4.31875 11.6816 1.33398 7.99967 1.33398C4.31778 1.33398 1.33301 4.31875 1.33301 8.00065C1.33301 11.6825 4.31778 14.6673 7.99967 14.6673Z"
					stroke="white" strokeOpacity="0.6" strokeLinecap="round" strokeLinejoin="round"/>
				<path
					d="M10.6663 5.33398H6.66634C6.31272 5.33398 5.97358 5.47446 5.72353 5.72451C5.47348 5.97456 5.33301 6.3137 5.33301 6.66732C5.33301 7.02094 5.47348 7.36008 5.72353 7.61013C5.97358 7.86018 6.31272 8.00065 6.66634 8.00065H9.33301C9.68663 8.00065 10.0258 8.14113 10.2758 8.39118C10.5259 8.64122 10.6663 8.98036 10.6663 9.33398C10.6663 9.68761 10.5259 10.0267 10.2758 10.2768C10.0258 10.5268 9.68663 10.6673 9.33301 10.6673H5.33301"
					stroke="white" strokeOpacity="0.6" strokeLinecap="round" strokeLinejoin="round"/>
				<path d="M8 12V4" stroke="white" strokeOpacity="0.6" strokeLinecap="round" strokeLinejoin="round"/>
			</g>
			<defs>
				<clipPath id="clip0_1_7570">
					<rect width={`${size}px`} height={`${size}px`} fill={fill}/>
				</clipPath>
			</defs>
		</svg>
	</>
}
